(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hs-brand-warranties"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hs-brand-warranties')) {
    customElements.define('hs-brand-warranties', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const track = this.querySelector('.hs-warranty__track');
        const previous = this.querySelector('[data-warranty-prev]');
        const next = this.querySelector('[data-warranty-next]');
        this.querySelector('.hs-warranty__controls').hidden = false;
        const update = () => {
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        };
        const move = direction => {
          const cards = Array.from(track.children);
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          const step = cards[0].getBoundingClientRect().width + gap;
          const perPage = Math.max(1, Math.round((track.clientWidth + gap) / step));
          const current = Math.round(track.scrollLeft / step);
          const target = Math.max(0, Math.min(cards.length - perPage, current + direction * perPage));
          track.scrollTo({ left: target * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), { signal });
        next.addEventListener('click', () => move(1), { signal });
        track.addEventListener('scroll', update, { passive: true, signal });
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        const openWarranty = id => {
          const item = document.getElementById(id);
          if (!item || !this.contains(item) || item.tagName !== 'DETAILS') return;
          item.open = true;
          item.scrollIntoView({ block: 'start', behavior: 'instant' });
          item.querySelector('summary').focus({ preventScroll: true });
        };
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
        if (location.hash) openWarranty(location.hash.slice(1));
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
